import { RestApi } from '../../common/services';

export type MonitoringNotificationType = 'change' | 'report' | 'deadline';

export interface UnsubscribeLinkParams {
  buildingId: string;
  profileId: string;
  type: MonitoringNotificationType;
  signature: string;
}

export interface UnsubscribeInfo {
  svjName: string;
  type: MonitoringNotificationType;
  enabled: boolean;
}

const toQueryString = (params: UnsubscribeLinkParams): string =>
  new URLSearchParams({
    buildingId: params.buildingId,
    profileId: params.profileId,
    type: params.type,
    signature: params.signature,
  }).toString();

/** Info k podepsanému odkazu (název SVJ + aktuální stav odběru). Nevyžaduje přihlášení. */
export const getUnsubscribeInfo = async (params: UnsubscribeLinkParams): Promise<UnsubscribeInfo> =>
  RestApi.get<never, UnsubscribeInfo>(`/public/monitoring-notification/unsubscribe?${toQueryString(params)}`);

/** Odhlášení / znovupřihlášení odběru přes podepsaný odkaz. Nevyžaduje přihlášení. */
export const setUnsubscribeState = async (
  params: UnsubscribeLinkParams,
  enabled: boolean
): Promise<UnsubscribeInfo> =>
  RestApi.post<UnsubscribeLinkParams & { enabled: boolean }, UnsubscribeInfo>(
    '/public/monitoring-notification/unsubscribe',
    { ...params, enabled }
  );
